import { render, staticRenderFns } from "./FragmentEditor.vue?vue&type=template&id=21fbb2f8&"
import script from "./FragmentEditor.vue?vue&type=script&lang=js&"
export * from "./FragmentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports